import { API_BASE, fetchJson } from './client';

export const tile = {
  getMetadata: (cacheHash: string) => fetchJson<any>(`/tiles/get-metadata/${cacheHash}`),
  getServerUrl: (cacheHash: string, format: 'png' | 'webp' = 'webp') =>
    `${API_BASE}/tiles/${cacheHash}/{z}/{x}/{y}.${format}`,
  getTileJsonUrl: (cacheHash: string) => `${API_BASE}/tiles/tilejson/${cacheHash}.json`,
  detectCache: (projectId: string) =>
    fetchJson<{
      found: boolean;
      cacheEntries?: Array<{ cacheHash: string; name?: string; dataType?: string; points?: number; bounds?: boolean }>;
      registered?: number;
      removed?: number;
    }>(`/tiles/detect/${projectId}`, { method: 'POST' }),
};
